<template>
  <div :class="{ 'not-sortable': notSortable }">
    <div
      class="single-subscription"
      v-if="showSubscription()"
      :class="{ sortable: permissions.sortSubscriptions }"
    >
      <div class="student-name">
        <strong>
          <span v-if="activity.require_anonymous_cv">
            Student {{ subscription.student.id }}<br>
          </span>
          <template v-if="permissions.admin">
            <a
              :href="`/admin/students/${subscription.student.id}/`"
              target="_blank"
            >
              {{ subscription.student.first_name }}
              {{ subscription.student.last_name }}
            </a>
          </template>
          <template v-else>
            <span v-if="!activity.require_anonymous_cv || activity.edition.schedule_final">
              {{ subscription.student.first_name }}
              {{ subscription.student.last_name }}
            </span>
          </template>
        </strong>

        <a
          class="btn btn-xs btn-default block"
          :href="`/admin/students/${subscription.student.id}/download-anonymous-cv`"
          target="_blank"
          v-if="activity.require_anonymous_cv"
        >
          download anonymous cv
        </a>

        <a
          class="btn btn-xs btn-primary block"
          :href="`/admin/students/${subscription.student.id}/download-cv`"
          target="_blank"
          v-if="canDownloadCV"
        >
          download cv
        </a>
      </div>

      <p
        v-for="study in subscription.student.studies"
        :key="study.id"
      >
        {{ getStudyName(study.label) }} ({{ study.pivot.study_year }})
      </p>

      <p>
        Permission to store CV:
        {{ subscription.student.accept_store_cv ? "Yes" : "No" }}
      </p>

      <p v-if="activity.average_grade_required">
        Average Score: {{ subscription.student.average_grade }}
      </p>

      <p>
        International student:
        {{ subscription.student.international_student ? "Yes" : "No" }}
      </p>

      <div v-if="permissions.admin">
        <p>Language: {{ subscription.student.language }}</p>
        <p>Present: {{ subscription.present ? "Yes" : "No" }}</p>
      </div>

      <div class="status" v-if="permissions.sortSubscriptions">
        <!--<manage-subscription-button :subscription="subscription" />-->

        <span v-if="subscription.status_reason">
          {{ subscription.status_reason }}
        </span>

        <span v-if="permissions.admin">
          <a
            :href="`/admin/subscriptions/${subscription.id}`"
            title="Delete subscription"
            data-method="delete"
            data-trans-button-cancel="Cancel"
            data-trans-button-confirm="Confirm"
            data-trans-title="Are you sure you want to do this?"
            class="btn btn-xs btn-danger"
          >
            <i class="fa fa-trash-o"></i> Delete subscription
          </a>

          <span class="pull-right">id: {{ subscription.id }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["activity", "subscription", "listType", "isDraggable"],

  computed: {
    canDownloadCV() {
      const { edition } = this.activity

      return !this.activity.require_anonymous_cv
        || (this.activity.require_anonymous_cv && edition.schedule_final)
        || this.permissions.admin
    },
    permissions() {
      return this.$store.state.permissions;
    },
    studyName() {
      return this.$store.getters.getStudyName(this.subscription.student.study);
    },
    notSortable() {
      return false;
      // return this.subscription.status !== null;
    },
  },

  methods: {
    getStudyName(studyKey) {
      return this.$store.getters.getStudyName(studyKey);
    },
    showSubscription() {
      return this.$store.getters.shouldShowSubscription(this.subscription);
    },
    moveToOtherList() {
      this.$store.dispatch("moveSubscription", {
        subscription: this,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.single-subscription {
  background-color: #eee;
  border-radius: 2px;
  padding: 10px 20px;
  margin: 10px 0;
  position: relative;
  cursor: pointer;

  p {
    margin-bottom: 4px;
  }

  .student-name {
    margin-bottom: 12px;
  }

  .status {
    margin-top: 12px;
  }

  &:hover {
    background-color: #fafafa;
  }
}
.single-subscription.sortable-ghost {
  opacity: 0.6;
}

.single-subscription .hamburger {
  position: absolute;
  right: 20px;
  bottom: 10px;
  font-size: 18px;
  width: 30px;
}

.sortable {
  cursor: grab;
}
.sortable-chosen .sortable,
.sortable-ghost .sortable {
  cursor: grabbing!important;
}
.not-sortable .sortable {
  cursor: default;
}
</style>
